import React from "react";
import { LoadingSpinner, PageLayout } from "shared";
import { CourseGroupCard, CourseListingText, useLearningMaterials } from "..";
import { useNavigate } from "react-router-dom";
import { getSelectedProgram } from "utils";
import { useAppScope, MwcdLogoComopent } from "master";

export const CourseGroupList = ({ type = null }) => {
  const navigate = useNavigate();
  const { isMWCD, lanSettings } = useAppScope();

  const selectedProgram = getSelectedProgram();
  const { selectedProgramName, programGroupList, displayName, courseType } =
    useLearningMaterials({
      load: true,
      type,
    });

  const { data, isLoading, isPending } = programGroupList;

  const isAssignment = courseType === 2;
  const isTheory = courseType === 0;
  const path = isAssignment
    ? "assignment"
    : isTheory
      ? "learningmaterials"
      : "practicals";

  const currentName = isAssignment
    ? `${CourseListingText.Assignment[lanSettings?.lan || "en"]}`
    : isTheory
      ? `${CourseListingText.LearningMaterials[lanSettings?.lan || "en"]}`
      : `${CourseListingText.LearningContent[lanSettings?.lan || "en"]}`;

  const handleCourseGroup = (element) => {
    if (element?.isActive) {
      sessionStorage.setItem("courseGroup", JSON.stringify(element));
      navigate(`/program/${path}/courseslist`);
    }
  };

  if (isPending || isLoading) {
    return <LoadingSpinner />;
  }

  const titleEndComponent = [
    <div className="logo-group">
      {isMWCD && (
        <MwcdLogoComopent customClass="logo-group-mwcd_PD marati_logo_empty_page" />
      )}
    </div>,
  ];

  return (
    <PageLayout
      title={displayName ? displayName : currentName}
      breadcrumb={[
        { label: selectedProgramName, location: "/program" },
        { label: displayName ? displayName : currentName },
      ]}
      titleEndComponent={titleEndComponent}
    >
      <div className="row">
        <div className="col-12">
          <div className="page-grid-items page-grid-items--box">
            {data &&
              data.map((element) => {
                return (
                  <CourseGroupCard
                    key={`CourseGroupCard-${element.id}`}
                    element={element}
                    isAssignment={isAssignment}
                    isTheory={isTheory}
                    displayDuration={selectedProgram?.displayDuration}
                    onClick={() => handleCourseGroup(element)}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
